export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-180x180-bfdda96ee27d86fb7c3ad783182f1067.png";